import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <section className="section-padding">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8}>
            <h1 className="fs-ss-56 fw-700 mb-3">404</h1>
            <h2 className="fs-ss-36 fw-700 mb-4">Page Not Found</h2>
            <p className="fs-ss-18 mb-5 font-montserrat">
              The page you are looking for does not exist or has been moved.
            </p>
            <Button 
              as={Link} 
              to="/" 
              variant="primary" 
              size="lg" 
              className="contact-btn"
            >
              BACK TO HOME
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NotFound; 